import styled from "styled-components";

import { colorsPalettes, setFont, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const CountryFilterStyledWrapper = styled.div`
    display: flex;
    width: 100%;
    .CountryFilter-dropdownButton {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        ${setFont({ $size: 14 })};
        box-sizing: border-box;
        min-width: 0;
    }

    .CountryFilter-dropdownButton-icon {
        min-width: 22px;
        height: 22px;
        margin-right: 8px;
    }

    .CountryFilter-dropdownButton-text {
        text-overflow: ellipsis;
        overflow: hidden;
        text-indent: 0;
    }
    .DropdownButton-text {
        width: calc(100% - 12px);
    }

    .CountryDropdownItem {
        &.DropdownItem {
            border-radius: 0;

            > div:first-child {
                align-items: center;
            }
        }
        .DropdownItem-iconContainer {
            padding: 0 0 0 16px;
        }
        .DropdownItem-countryFlag {
            width: 22px;
            height: 22px;
        }
    }

    .CountryFilterCompact {
        .DropdownContent-search {
            padding-left: 42px;
            height: 30px;
        }
        &.DropdownContent-searchContainer {
            margin: 9px 0 0 0;
        }
    }

    .CountryFilterCompactItem {
        a,
        a:hover,
        a:focus {
            text-decoration: none;
        }
        .CountryDropdownItem {
            .DropdownItem-text {
                max-width: 175px;
            }
            .DropdownItem-iconContainer {
                padding: 0 0 0 47px;
            }
        }
    }
    .has-value {
        color: ${colorsPalettes.carbon[400]};
    }
`;

const StyledAllCountriesItem = styled.div`
    height: 48px;
    line-height: 48px;
    padding: 0 8px;
`;

const StyledAllCountriesInfoIcon = styled.div`
    margin-left: 5px;
    margin-top: 3px;
`;

export const CountryDetailsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    text-indent: 0;
`;
export const NotificationWrapper = styled.div``;

export const SortingButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledButton = styled(Button)`
    ${setFontVariant("captionTitle", colorsPalettes.carbon[300])};
    &:hover {
        background-color: unset;
        ${setFontVariant("captionTitle", colorsPalettes.carbon[500])};
    }
`;

export const StyledBetaItemWrapper = styled.div`
    width: 100%;
    display: flex;
    position: relative;
`;

export const StyledBetaTag = styled.div`
    position: absolute;
    right: 10%;
    top: 28%;
`;

export const StyledChildrenWrapper = styled.div`
    width: 100%;
`;

// you can wrap the country filter with this component for preventing the border left
export const CountryFilterWrapper = styled.div`
    .DropdownButton--filtersBarDropdownButton {
        border-left: none;
    }
`;
